import { Modal } from '../classes/classModalWindow'

export const CallModalWindow = function(params) {
  const modal = new Modal()
}